var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { ESendCodeType } from "@/enum/ESendCodeType";
import Component from 'vue-class-component';
import CommonService from "@/api/CommonService";
import LoginService from "@/api/LoginService";
import { mapGetters } from 'vuex';
var checkMsg = '发送验证码';
var VerifySmsCode = (function (_super) {
    __extends(VerifySmsCode, _super);
    function VerifySmsCode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingCode = false;
        _this.checkMsg = checkMsg;
        _this.timeFlag = null;
        _this.modalShow = false;
        _this.checkNo = '';
        return _this;
    }
    VerifySmsCode.prototype.created = function () {
        this.service = LoginService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    VerifySmsCode.prototype.mounted = function () {
    };
    VerifySmsCode.prototype.beforeDestroy = function () {
        this.clearFlag();
    };
    VerifySmsCode.prototype.clearFlag = function () {
        clearInterval(this.timeFlag);
        this.timeFlag = 0;
        this.checkMsg = checkMsg;
    };
    VerifySmsCode.prototype.getCheckNo = function () {
        var _this = this;
        if (this.timeFlag || this.loadingCode) {
            return;
        }
        this.loadingCode = true;
        this.commonService.sendCode({ phone: this.user.phone, type: ESendCodeType.unbindWechat }).then(function (res) {
            var _a = res.data, code = _a.code, success = _a.success;
            if (code === 71) {
                _this.$confirm('该账号未注册，是否立即注册', '提示', {})
                    .then(function () {
                    _this.$emit('register', { unionid: _this.unionId, openid: _this.openId });
                }, function () { });
            }
            else {
                var num_1 = 60;
                _this.checkMsg = num_1 + "s \u540E\u91CD\u8BD5";
                _this.timeFlag = setInterval(function () {
                    num_1--;
                    if (num_1 === 0) {
                        _this.clearFlag();
                    }
                    else {
                        _this.checkMsg = num_1 + "s \u540E\u91CD\u8BD5";
                    }
                }, 1000);
                _this.$message.success('发送成功！');
            }
        }, function (error) {
            console.log('------err', error);
            _this.$message.error(error.message);
        }).finally(function () {
            _this.loadingCode = false;
        });
    };
    VerifySmsCode.prototype.close = function () {
        this.modalShow = false;
        this.checkNo = '';
        this.clearFlag();
    };
    VerifySmsCode.prototype.show = function () {
        this.modalShow = true;
    };
    VerifySmsCode.prototype.confirm = function () {
        this.$emit('success', this.checkNo);
    };
    VerifySmsCode = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                'user': 'user'
            }), { displayPhone: function () {
                    return String(this.user.phone).replace(/^(\d{3})(\d{4})(\d+)$/, '$1****$3');
                } })
        })
    ], VerifySmsCode);
    return VerifySmsCode;
}(Vue));
export default VerifySmsCode;
